module.exports = __webpack_public_path__ + "img/img-robo.1fa51df0.jpg";